document.addEventListener("DOMContentLoaded", function () {
    console.log("Script Loaded...");
   document.querySelectorAll('.seller-banner.splide').forEach((slider, index) => {
    var splide = new Splide(slider, {
      type: 'loop',
      perPage: 5.5,
      perMove: 1,
      arrows: false,
      pagination: false,
      speed: 1500,
      gap: '20px',
      rewind: true, 
      rewindByDrag: true,
      breakpoints: {
        1024: { perPage: 3.5 },
        768: { perPage: 2.5 },
        480: { perPage: 1.5, gap: '10px' }
      }
    });
    splide.mount(); 
    var prevButton = slider.querySelector('.splide_prev');
    var nextButton = slider.querySelector('.splide_next');
    function updateButtons() {
      if (splide.index === 0) {
        prevButton.classList.add('disabled');
      } else {
        prevButton.classList.remove('disabled');
      }
      if (splide.index >= splide.Components.Controller.getEnd()) {
        nextButton.classList.add('disabled');
      } else {
        nextButton.classList.remove('disabled');
      }
    }
    updateButtons();
    splide.on('moved', updateButtons);
    prevButton.addEventListener('click', function () {
      if (splide.index > 0) {
        splide.go('-1');
      }
    });
    nextButton.addEventListener('click', function () {
      if (splide.index < splide.Components.Controller.getEnd()) {
        splide.go('+1');
      }
    });
  });
  // 
  // slider banner scrol
    //  var main = new Splide('#banner-slider', {
    //   type: 'fade',
    //   arrows: false,
    //   pagination: false,
    //   speed: 1500, 
    // }).mount();
  //   document.querySelector('.scroll').addEventListener('click', function() {
  //       document.querySelector('.section-collection-list').scrollIntoView({ behavior: 'smooth' });
  // });
  // index video section
    let ourStoryVideo = document.querySelector('.ourStoryVideo');
    let ourStoryPlayBtn = document.querySelector('.ourStoryPlay');
    let poster = document.querySelector('.poster-img');
    if (ourStoryVideo && ourStoryPlayBtn) {
        function togglePlayPause() {
            if (ourStoryVideo.paused || ourStoryVideo.ended) {
                ourStoryVideo.play();
                ourStoryPlayBtn.style.display = 'none';
                if (poster) poster.style.display = 'none';
            } else {
                ourStoryVideo.pause();
                ourStoryPlayBtn.style.display = 'flex';
            }
        }
        ourStoryPlayBtn.addEventListener('click', togglePlayPause);
        ourStoryVideo.addEventListener('click', togglePlayPause);
        ourStoryVideo.addEventListener('play', () => {
            ourStoryPlayBtn.style.display = 'none';
            if (poster) poster.style.display = 'none';
        });
        ourStoryVideo.addEventListener('pause', () => {
            ourStoryPlayBtn.style.display = 'flex';
        });
        ourStoryVideo.addEventListener('ended', () => {
            ourStoryPlayBtn.style.display = 'flex';
        });
    }
  // 

  // product detail tab functionality
  // const tabs = document.querySelectorAll("ul.prd--tabs > li");
  // tabs.forEach(tab => {
  //   tab.addEventListener("click", function () {
  //     const tabId = this.getAttribute("data-tab");
  //     console.log(tabId);
  //     const tabContent = document.getElementById(tabId);
  //     if (!tabContent) return; 
  //     tabs.forEach(t => t.classList.remove("current--menu"));
  //     document.querySelectorAll(".prd--tab--content").forEach(content => content.classList.remove("current"));
  //     this.classList.add("current--menu");
  //     tabContent.classList.add("current");
  //   });
  // });

    const tabMenus = document.querySelectorAll(".prd--tabs li");
  const tabContents = document.querySelectorAll(".prd--tab--content");

  if (!tabMenus.length || !tabContents.length) return;

  tabMenus.forEach(tab => {
    tab.addEventListener("click", function () {
      // Remove current--menu class from all tabs
      tabMenus.forEach(t => t.classList.remove("current--menu"));

      // Hide all content tabs
      tabContents.forEach(content => content.classList.remove("current"));

      // Add current--menu to clicked tab
      this.classList.add("current--menu");

      // Show corresponding content tab
      const selectedTab = this.getAttribute("data-tab");
      const activeContent = document.getElementById(selectedTab);

      if (activeContent) {
        activeContent.classList.add("current");
      }
    });
  });
  
  // filter price range
var lowerSlider = document.querySelector('#lower');
    var upperSlider = document.querySelector('#upper');
    var minPriceInput = document.querySelector('#Filter-Price-GTE');
    var maxPriceInput = document.querySelector('#Filter-Price-LTE');
    var priceRangeText = document.querySelector('.facets__selecteds');
  console.log(priceRangeText);
      if (!lowerSlider || !upperSlider || !minPriceInput || !maxPriceInput || !priceRangeText) {
    console.warn("Some slider/filter elements are missing on this page. Skipping price filter script.");
    return;
  }
    // Set initial values
    updateValues();
    // Event listeners for updating values dynamically
    lowerSlider.addEventListener('input', updateValues);
    upperSlider.addEventListener('input', updateValues);
    function updateValues() {
        var lowerVal = parseInt(lowerSlider.value);
        var upperVal = parseInt(upperSlider.value);
        // Ensure lower slider never exceeds (max - 4)
        if (lowerVal > upperVal - 4) {
            lowerSlider.value = upperVal - 4;
            lowerVal = parseInt(lowerSlider.value);
        }
        // Ensure upper slider never goes below (min + 4)
        if (upperVal < lowerVal + 4) {
            upperSlider.value = lowerVal + 4;
            upperVal = parseInt(upperSlider.value);
        }
        // Update input fields
        minPriceInput.value = lowerVal;
        maxPriceInput.value = upperVal;
        console.log(lowerVal);
        console.log(upperVal);
        // Update displayed price range in span
        priceRangeText.innerHTML = `Price: $${lowerVal} - $${upperVal}`;
    }
  });


// 
document.querySelectorAll("li header-menu details").forEach((detail) => {
    detail.addEventListener("mouseenter", function () {
        this.classList.add("kkk");
        this.setAttribute("open", "true");
        const submenu = this.querySelector(".submenu");
        if (submenu) {
            submenu.setAttribute("aria-expanded", "true");
        }
    });
    detail.addEventListener("mouseleave", function () {
        this.classList.remove("kkk");
        this.removeAttribute("open");
        document.querySelectorAll(".header__menu-item").forEach(item => {
            item.setAttribute("aria-expanded", "false");
        });
    });
});